import { state } from "./state";
import { mutations } from "./mutations";

export const notifications = {
  state,
  mutations
};
